import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgProtectGlyph from './svgs/ProtectGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var protectGlyph = (props => useIcon(SvgProtectGlyph, SvgProtectGlyph, props));

export { protectGlyph as default };
